import { QA_PROTOCOL } from "../actions/utilities";

const INITIAL_STATE = {
  createQaProtocolLoading: false,
  createQaProtocolSuccess: false,
  createQaProtocolFailure: false,
  createQaProtocolError: null,
  createQaProtocol: null,

  EditQaProtocolLoading: false,
  EditQaProtocolSuccess: false,
  EditQaProtocolFailure: false,
  EditQaProtocolError: null,
  EditQaProtocol: null,

  getQaProtocolListLoading: false,
  getQaProtocolListSuccess: false,
  getQaProtocolListFailure: false,
  getQaProtocolListError: null,
  getQaProtocolList: [],

  DeleteQaProtocolLoading: false,
  DeleteQaProtocolSuccess: false,
  DeleteQaProtocolFailure: false,
  DeleteQaProtocolError: null,

  reportQaProtocolLoading: false,
  reportQaProtocolSuccess: false,
  reportQaProtocolFailure: false,
  reportQaProtocolError: null,
  reportQaProtocol: null,
};

export const qaProtocolReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case QA_PROTOCOL.CREAT_QA_PROTOCOL_REQUEST:
      return {
        ...state,
        createQaProtocolLoading: true,
        createQaProtocolSuccess: false,
        createQaProtocolFailure: false,
        createQaProtocolError: null,
      };
    case QA_PROTOCOL.CREAT_QA_PROTOCOL_SUCCESS:
      let createProtocol = state.getQaProtocolList;
      createProtocol.unshift(action.payload);
      return {
        ...state,
        createQaProtocolLoading: false,
        createQaProtocolSuccess: true,
        createQaProtocolFailure: false,
        createQaProtocolError: null,
        // createQaProtocol: action.payload,
        getQaProtocolList: createProtocol,
      };
    case QA_PROTOCOL.CREAT_QA_PROTOCOL_FAILURE:
      return {
        ...state,
        createQaProtocolLoading: false,
        createQaProtocolSuccess: false,
        createQaProtocolFailure: true,
        createQaProtocolError: action.payload,
      };

    case QA_PROTOCOL.EDIT_QA_PROTOCOL_REQUEST:
      return {
        ...state,
        EditQaProtocolLoading: true,
        EditQaProtocolSuccess: false,
        EditQaProtocolFailure: false,
        EditQaProtocolError: null,
      };
    case QA_PROTOCOL.EDIT_QA_PROTOCOL_SUCCESS:
      let editProtocol = state.getQaProtocolList;
      if (editProtocol.length > 0) {
        for (var i = 0; i < editProtocol.length; i++) {
          if (editProtocol[i]._id === action.payload._id) {
            editProtocol[i] = action.payload;
          }
        }
      }
      return {
        ...state,
        EditQaProtocolLoading: false,
        EditQaProtocolSuccess: true,
        EditQaProtocolFailure: false,
        EditQaProtocolError: null,
        getQaProtocolList: editProtocol,
        // EditQaProtocol: action.payload,
      };
    case QA_PROTOCOL.EDIT_QA_PROTOCOL_FAILURE:
      return {
        ...state,
        EditQaProtocolLoading: false,
        EditQaProtocolSuccess: false,
        EditQaProtocolFailure: true,
        EditQaProtocolError: action.payload,
      };

    case QA_PROTOCOL.GET_ALL_QA_PROTOCOL_REQUEST:
      return {
        ...state,
        getQaProtocolListLoading: true,
        getQaProtocolListSuccess: false,
        getQaProtocolListFailure: false,
        getQaProtocolListError: null,
      };
    case QA_PROTOCOL.GET_ALL_QA_PROTOCOL_SUCCESS:
      return {
        ...state,
        getQaProtocolListLoading: false,
        getQaProtocolListSuccess: true,
        getQaProtocolListFailure: false,
        getQaProtocolListError: null,
        getQaProtocolList: action.payload,
      };
    case QA_PROTOCOL.GET_ALL_QA_PROTOCOL_FAILURE:
      return {
        ...state,
        getQaProtocolListLoading: false,
        getQaProtocolListSuccess: false,
        getQaProtocolListFailure: true,
        getQaProtocolListError: action.payload,
      };

    case QA_PROTOCOL.DELETE_QA_PROTOCOL_REQUEST:
      return {
        ...state,
        DeleteQaProtocolLoading: true,
        DeleteQaProtocolSuccess: false,
        DeleteQaProtocolFailure: false,
        DeleteQaProtocolError: null,
      };
    case QA_PROTOCOL.DELETE_QA_PROTOCOL_SUCCESS:
      let protocolDelete = state.getQaProtocolList;
      let payload = protocolDelete.filter((item) => item._id != action.payload);
      return {
        ...state,
        DeleteQaProtocolLoading: false,
        DeleteQaProtocolSuccess: true,
        DeleteQaProtocolFailure: false,
        DeleteQaProtocolError: null,
        getQaProtocolList: payload,
      };
    case QA_PROTOCOL.DELETE_QA_PROTOCOL_FAILURE:
      return {
        ...state,
        DeleteQaProtocolLoading: false,
        DeleteQaProtocolSuccess: false,
        DeleteQaProtocolFailure: true,
        DeleteQaProtocolError: action.payload,
      };
    case QA_PROTOCOL.QA_PROTOCOL_REPORT_REQUEST:
      return {
        ...state,
        reportQaProtocolLoading: true,
        reportQaProtocolSuccess: false,
        reportQaProtocolFailure: false,
        reportQaProtocolError: null,
      };
    case QA_PROTOCOL.QA_PROTOCOL_REPORT_SUCCESS:
      return {
        ...state,
        reportQaProtocolLoading: false,
        reportQaProtocolSuccess: true,
        reportQaProtocolFailure: false,
        reportQaProtocolError: null,
        reportQaProtocol: action.payload,
      };
    case QA_PROTOCOL.QA_PROTOCOL_REPORT_FAILURE:
      return {
        ...state,
        reportQaProtocolLoading: false,
        reportQaProtocolSuccess: false,
        reportQaProtocolFailure: true,
        reportQaProtocolError: action.payload,
      };
    default:
      return state;
  }
};
